<script setup>
import MainMenu from "../components/MainMenu.vue";
import Header from "../components/Header.vue";
</script>

<template>
  <div class="flex min-h-screen max-h-screen h-screen overflow-hidden">
    <!-- Боковая панель -->
    <aside class="py-2 pl-2 md:py-4 md:pl-4 max-h-full">
      <MainMenu />
    </aside>

    <!-- Основной контент -->
    <div class="flex-1 flex flex-col max-h-full overflow-hidden bg-white">
      <Header class="flex-shrink-0" />

      <!-- Две колонки: на мобильных вертикально, на lg — 3/4 + 1/4 -->
      <div class="flex flex-1 flex-col lg:flex-row gap-2 md:gap-4 p-2 pt-1 md:p-4 md:pt-2 min-h-0 overflow-auto">
        <div class="basis-auto lg:basis-3/4 lg:grow min-w-0 lg:max-h-full">
          <slot name="main" />
        </div>
        <div class="w-full lg:basis-1/4 lg:shrink-0 lg:min-w-[250px] lg:max-h-full flex flex-col gap-4 mt-2 lg:mt-0">
          <slot name="sidebar"/>
        </div>
      </div>



    </div>
  </div>
</template>
